
































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
@Component({
  components: {},
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.TelegramSearchOrderServiceProxy();
  }
  input: proxy.TelegramSearchOrderPageInputDto =
    new proxy.TelegramSearchOrderPageInputDto();
  sub_id = 0;
  createOrEditShow = false;
  createrange = [];
  BalanceTypes = [];
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },

    {
      title: "单号",
      slot: "tid",
      width: 300,
    },
    {
      title: "商户",
      slot: "mid",
      width: 180,
    },
    {
      title: "通道",
      slot: "payChannelName",
      width: 200,
    },
    {
      title: "金额",
      slot: "money",
      width: 100,
    },
    {
      title: "订单状态",
      slot: "payOrderStatusName",
      width: 140,
    },
    {
      title: "查单状态",
      slot: "status",
      width: 120,
    },
    {
      title: "处理耗时",
      slot: "consuming",
      width: 150,
    },
    {
      title: "创建时间",
      key: "creationTime",
      width: 180,
    },
    {
      title: "处理时间",
      key: "handleTime",
      width: 180,
    },
  ];

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.prox.queryModelList(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    // this.prox.export(this.input).then((x) => {
    //   location.href =
    //     AppConsts.remoteServiceBaseUrl +
    //     '/File/DownloadTempFile?FileToken=' +
    //     x.fileToken +
    //     '&fileName=' +
    //     x.fileName +
    //     '&fileType=' +
    //     x.fileType;
    // });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.getpage();
  }
}
